export default "__VITE_ASSET__Cf55r4Nh__"